var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"title":"Search By Group"}},[_c('v-text-field',{attrs:{"label":"Search by group name"},model:{value:(_vm.groupSearch),callback:function ($$v) {_vm.groupSearch=$$v},expression:"groupSearch"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ce5b660","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Groups/GroupsSearchPanel.vue
// module id = null
// module chunks = 